import React from "react";
import {
	app_id,
	locale_cookie_group,
	sidebar_menu_groups_statuses_storage_field_name,
	sidebar_menu_shrank_cookie_group,
	skin_mode_cookie_group
} from 'Config/app';
import {translate} from "Core/i18n";

/**
 * Cookie policy for sr-Cyrl-RS locale
 * @note This will automatically be used in CookiePolicy component (index.js) if sr-Cyrl-RS is the current locale.
 * There is no need to use this component directly.
 *
 * @param {any} props - Any prop that will be added to the DIV element.
 * @return {JSX.Element}
 * @constructor
 */
function CookiePolicySrCyrlRS(props) {
	return (
		<div {...props}>
			<h2>О колачићима</h2>
			<p>Колачић на веб сајту је мала текстуална датотека коју веб сајт чува на Вашем рачунару или мобилном уређају када га посетите. Замислите га као меморију веб сајта. Ове датотеке су врло честе и неопходне за ефикасно функционисање интернета. Колачићи омогућавају веб сајту да "запамти" Ваше акције и подешавања (као што су информације о пријави, избор језика или преференце) током одређеног временског периода, тако да не морате поново да их уносите када се вратите на сајт или прелазите са једне странице на другу.</p>
			<p>Колачићи имају неколико важних функција. Неки су <strong>{translate('name', 'CookieSettings.tab.@cookieGroup:necessary').toLowerCase()}</strong> за основно функционисање веб сајта - на пример, да Вам омогуће пријаву. Други, често названи <strong>{translate('name', `CookieSettings.tab.@cookieGroup:functional`).toLowerCase()}</strong> или <strong>{translate('name', `CookieSettings.tab.@cookieGroup:analytics`).toLowerCase()}</strong> колачићи, помажу нам да разумемо како посетиоци користе наш сајт, што нам омогућава да побољшамо изглед, садржај и корисничко искуство. Коначно, <strong>{translate('name', `CookieSettings.tab.@cookieGroup:marketing`)}</strong> колачићи се могу користити за приказивање реклама које су релевантније за Вас и Ваша интересовања, или за ограничавање броја приказивања одређене рекламе.</p>
			<p>Ви имате контролу над тим које колачиће прихватате. Већина веб претраживача је подешена да подразумевано прихвата колачиће, али можете користити овај дијалог да изаберете колачиће које желите да дозволите. Међутим, имајте на уму да ако одлучите да одбијете колачиће, неки делови нашег веб сајта можда неће правилно функционисати или Вам могу постати недоступни. За детаљније информације о управљању и брисању колачића, можете консултовати одељак "Помоћ" Вашег претраживача.</p>
			<p>Листу свих колачића које користимо можете пронаћи у табели "Спецификација колачића" испод.</p>

			<h2>Спецификација колачића</h2>
			<div className="data-table-component standard">
				<table>
					<thead>
						<tr>
							<th className="column"><div className="content">КАТЕГОРИЈА</div></th>
							<th className="column" width="1"><div className="content">НАЗИВ</div></th>
							<th className="column"><div className="content">ОПИС</div></th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_pauseRequests</div></td>
							<td><div className="content">Колачић који се користи за паузирање системских процеса</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_authToken</div></td>
							<td><div className="content">Колачић који се користи за ауторизацију улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_authTokenData</div></td>
							<td><div className="content">Колачић који садржи ауторизациони кључ тренутно улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_refreshToken</div></td>
							<td><div className="content">Колачић који се користи за ауторизацију улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_refreshingToken</div></td>
							<td><div className="content">Колачић који се користи за ауторизацију улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_acl</div></td>
							<td><div className="content">Колачић који садржи листу привилегија тренутно улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_currentUserName</div></td>
							<td><div className="content">Колачић који садржи корисничко име тренутно улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_currentUser</div></td>
							<td><div className="content">Колачић који садржи системске податке тренутно улогованог корисника (корисничко име, тип, итд.)</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_userActivity</div></td>
							<td><div className="content">Колачић који садржи системске податке о активности тренутно улогованог корисника</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_cookie_consent_settings</div></td>
							<td><div className="content">Колачић који садржи информацију о томе које колачиће је корисник прихватио</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${locale_cookie_group}`)}</div></td>
							<td><div className="content">{app_id}_locale</div></td>
							<td><div className="content">Колачић који садржи системски код региона на основу којег се одређује језик који ће бити коришћен</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${sidebar_menu_shrank_cookie_group}`)}</div></td>
							<td><div className="content">sidebar_menu_shrank</div></td>
							<td><div className="content">Колачић који одређује величину главног навигационог менија</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:necessary`)}</div></td>
							<td><div className="content">{sidebar_menu_groups_statuses_storage_field_name}</div></td>
							<td><div className="content">Колачић који одређује који елементи главног навигационог менија ће бити отворени</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${skin_mode_cookie_group}`)}</div></td>
							<td><div className="content">skin_mode</div></td>
							<td><div className="content">Колачић који одређује тему (боје) апликације</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${skin_mode_cookie_group}`)}</div></td>
							<td><div className="content">use_system_skin_mode</div></td>
							<td><div className="content">Колачић који одређује тему (боје) апликације</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:functional`)}</div></td>
							<td><div className="content">emoji-mart.frequently</div></td>
							<td><div className="content">Колачић који чува листу најчешће коришћених емотикона како би они били доступни приликом убациванја емотикона у неки садржај</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:functional`)}</div></td>
							<td><div className="content">emoji-mart.last</div></td>
							<td><div className="content">Колачић који чува информацију о последње коришћеном емотикону</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:functional`)}</div></td>
							<td><div className="content">calendar_preferences</div></td>
							<td><div className="content">Колачић који чува подешавања календара на почетној страници</div></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default CookiePolicySrCyrlRS;